module.exports = __webpack_public_path__ + "img/wave-footer.3cf6704b.png";